import Hex from './hex';

export default class StopColor {
	#color: Hex;
	#offset: number;

	/**
	 * The stop-color CSS property defines the color to use for an SVG <stop> element within a gradient. If present, it overrides the element's stop-color attribute.
	 *
	 * @param color An instance of the Hex class
	 * @param offset A number from 0 to 100
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/stop-color} for syntax
	 */
	public constructor(color: Hex, offset: number) {
		assertIsInstanceOfHex(color);
		assertIsFromZeroToHundred(offset);
		this.#color = color;
		this.#offset = offset;
	}

	/**
	 * Returns the StopColor value as a '#RRGGBBAA number%' string
	 *
	 * @returns String
	 */
	public toStyleString(): string {
		return `${this.#color.toStyleString()} ${this.#offset}%`;
	}
}

function assertIsFromZeroToHundred(value: unknown): asserts value is number {
	if (typeof value === 'number' && value >= 0 && value <= 100) {
		return;
	}
	throw new RangeError(`[${String(value)}] is invalid, must be from 0 to 100`);
}

function assertIsInstanceOfHex(value: unknown): asserts value is Hex {
	if (value instanceof Hex) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be instance of Hex`);
}
